import { ProfessionId, PROFESSIONS } from "./professions"

export const getProfessionConfig = (id: ProfessionId) =>
	PROFESSIONS.find((x) => x.id === id)
